/* eslint-disable eqeqeq */
/* eslint-disable consistent-return */
/* eslint-disable object-shorthand */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import {
  Grid,
  Paper,
  Divider,
  DialogContent,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  IconButton,
  InputAdornment,
  Box,
  Switch,
  Select,
  makeStyles,
  InputBase,
  Tooltip,
} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import withStyles from '@material-ui/core/styles/withStyles'
import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ArchiveIcon from '@material-ui/icons/Archive'
import { useConfirm } from 'material-ui-confirm'
import { format } from 'date-fns'
// import 'react-tabs/style/react-tabs.css'

import AsyncRequest from '../../components/AsyncRequest'
import styles from '../../../resources/theme/global'
import {
  applyDiscount,
  duplicateTime,
  truncateNumber,
  dateFormatedFullDate,
  getPercentageOf,
  getPercetageApplicated,
  getPercentValue,
  exportFormatedMoney,
} from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import {
  findClient,
  archive,
  fetchAttendanceInit,
  fetchDocumentContexts,
} from '../AttendanceActions'
import Form from '../../clients/pages/Form'
import SelectField from '../../components/SelectField'
import { SNACKBAR } from '../../main/MainActions'
import consts from '../../../util/consts'

import Modal from './ModalGetInfos'
import TotalTable from './TotalTable'
import TableServices from './TableService'
import Calendar from './Calendar'
import ModalShowOpenedServices from './ModalShowOpenedServices'
// import Tabs from '@material-ui/core/Tabs'
// import Tab from '@material-ui/core/Tab'
import colors from '../../../assets/colors'
import {
  mdiAccountEdit,
  mdiCalendarCheck,
  mdiCheck,
  mdiCheckBold,
  mdiChevronLeft,
  mdiChevronRight,
  mdiCommentTextMultiple,
  mdiMagnifyExpand,
  mdiSearchWeb,
  mdiWater,
} from '@mdi/js'
import Icon from '@mdi/react'
import { Visibility } from '@material-ui/icons'
import Tabs from '../../../components/hooks/BaseTabs/Tabs'
import Tab from '../../../components/hooks/BaseTabs/Tab'
import { Link, Route } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import { useLocation, useRouteMatch, useHistory } from 'react-router-dom'
import queryString from 'query-string'
import {
  applicateMultipleDiscount,
  getServiceItemKey,
  isItemFinalized,
  REWORK_BLOCKED_MESSAGE,
  updateDiscountOrQuantity,
  updateFinalValue,
  updateMeasures,
  updateRework,
} from './ServiceItemUpdateHelper'
import Decimal from 'decimal.js'
import { fetchTriggers } from '../../crm/triggers/TriggersActions'
import InputNumberCustom from '../../../components/hooks/BaseInputNumber'
import CreateServiceTypeModal from '../../service-type/pages/New'
import { fetchServiceType } from '../../service-type/ServiceTypeActions'
import {
  eraseClientCashback,
  fetchClientCashback,
} from '../../clients/ClientActions'
import ClientHistoric from './ClientHistoric'
import { createPortal } from 'react-dom'

export const ATTENDANCE_HISTORIC_SLOT_ID = 'attendance-historic-slot'

const useStyles = makeStyles({
  footer: {
    widht: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '12px',
    marginTop: '2em',
  },
  submmitButton: {
    minWidth: '99px',
    minHeight: '30px',
    borderRadius: '15px',
    padding: '2px 16px',
    fontWeight: 'normal',
    textTransform: 'capitalize',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    color: '#FFFF',
    backgroundColor: colors.primary,
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: colors.primary,
      opacity: 0.7,
    },
  },
})

function Attendance(props) {
  const { classes, onClose, data, path, updateOnlyServiceValue = false } = props

  const [client, setClient] = useState(null)
  const [currentService, setCurrentService] = useState()
  const [open, setOpen] = useState(false)
  const [currentIndex, setCurrentIndex] = useState({})
  const [canCorrectFinalValue, setCanCorrectFinalValue] = useState(false)
  const [generalFinalAltered, setGeneralFinalAltered] = useState(false)
  const [form, setForm] = useState({
    services: [],
    client: [],
    general_discount: '',
    final_value_discount: 0,
    status: '',
    know_way_id: '',
    general_service_observations: '',
    general_observations: '',
    supplier: '',
    commission: false,
    rework: false,
    payment_options: [],
    all_in_rework: false,
    service_address_active: false,
    recurrence_days: null,
    final_value_with_cashback: null,
    cashback_applied: 0,
    cashback_value: 0,
    created_by_web: true,
    // Flag de "form pronto/hidratado" (nome herdado; NÃO é o dirty clássico).
    // Em atendimento novo o form já está pronto no render 0 (não há `data` para
    // carregar), então nasce `true`. Em edição, nasce `false` e o `initForm`
    // liga quando os dados do backend chegam. Ver docs/correcao-dirty-total-com-desconto.md
    dirty: path === 'new',
  })
  const dispatch = useDispatch()
  const services = useSelector(state => state.attendance.services)
  const paymentMethods = useSelector(state => state.attendance.paymentMethods)
  const filters = useSelector(state => state.attendance.filters)
  const recurrenceTrigger = useSelector(
    state => state.attendance.recurrenceTrigger
  )
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate } = usePermissions()
  const cashback = useSelector(state => state.client.cashback)

  const [percentualDiscountAltered, setPercentualDiscountAltered] =
    useState(false)
  const [finalValueAltered, setFinalValueAltered] = useState(false)
  const [recalculate, setRecalculate] = useState(false)

  const [openCreateServiceType, setOpenCreateServiceType] = useState(false)

  // O botão de histórico fica no cabeçalho da página (New/Edit), ao lado do
  // calendário, mas depende do cliente e do `fillNewServices` deste form — por
  // isso é renderizado via portal no slot que a página expõe.
  const [historicSlot, setHistoricSlot] = useState(null)

  useEffect(() => {
    setHistoricSlot(document.getElementById(ATTENDANCE_HISTORIC_SLOT_ID))
  }, [])

  const [clientAddress, setClientAddress] = useState({
    cep: '',
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    uf: '',
  })

  const [serviceAddress, setServiceAddress] = useState({
    cep: '',
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    uf: '',
  })

  const { url } = useRouteMatch()
  const params = useLocation()

  const objectParams = useMemo(() => queryString.parse(params.search), params)

  const [value, setValue] = useState(Number(objectParams?.value) || 0)

  const styles = useStyles()

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const confirm = useConfirm()
  const history = useHistory()

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  const changeOptionType = (index, id) => {
    const items = [...form.services]

    items[index].options = { ...items[index].options, type: id }

    setForm({
      ...form,
      services: items,
    })
  }

  const updateField = useCallback(
    (name, value) => {
      setForm({ ...form, [name]: value })
    },
    [form]
  )

  const updateClient = (name, value) => {
    setClient(value)
  }

  /**
   * @author Heitor Santos 30/07/2026
   * `documents` (fotos já gravadas) viram `images`, o array que o modal de fotos
   * do item manipula e que alimenta o sync-images depois do save. `documents`
   * é preservado como baseline para detectar o que mudou.
   */
  const initItemImages = (services = []) =>
    services.map(service => ({
      ...service,
      images: (service?.documents || []).map(document => ({
        uid: `p-${document.id}`,
        kind: 'path',
        context: document.context || '',
        document_id: document.id,
        path: document.path,
        link: document.link,
      })),
    }))

  const initForm = () => {
    const hasCommission = data?.services?.some(s => s?.commissioned_person)

    setForm({
      ...form,
      ...data,
      services: initItemImages(data?.services),
      dirty: true,
      know_way_id: data?.know_way_id,
      commission: hasCommission || false,
    })

    setClientAddress({
      cep: data?.client?.cep || '',
      street: data?.client?.street || '',
      number: data?.client?.number || '',
      complement: data?.client?.complement || '',
      neighborhood: data?.client?.neighborhood || '',
      city: data?.client?.city || '',
      uf: data?.client?.uf || '',
    })

    setServiceAddress({
      cep: data?.address?.cep || '',
      street: data?.address?.street || '',
      number: data?.address?.number || '',
      complement: data?.address?.complement || '',
      neighborhood: data?.address?.neighborhood || '',
      city: data?.address?.city || '',
      uf: data?.address?.uf || '',
    })

    if (updateOnlyServiceValue) setValue(1)
  }

  useEffect(() => {
    if (path === 'new') setForm(prev => ({ ...prev, dirty: true }))
    else setCanCorrectFinalValue(true)
  }, [path])

  useEffect(() => {
    if (!data) return
    if (form.dirty) return

    initForm()
  }, [data])

  const toastError = message => {
    dispatch({
      type: SNACKBAR.HARDFAIL,
      error: { message: message },
    })
  }

  const returnFinalValue = (services = []) => {
    const { dirty, services: formServices } = form

    // Enquanto o form não estiver hidratado, preserva o valor atual em vez de
    // devolver `undefined` (o que zeraria/congelaria o campo controlado).
    if (!dirty) return form.final_value_discount

    if (services.length > 0) {
      const generalFinalValue = services.reduce((total, item) => {
        const { final_value, quantity, discount, default_value, is_rework } =
          item

        let withDiscount = 0

        if (final_value) {
          withDiscount = truncateNumber(final_value)
        } else {
          const itemDefaultFinalValue = default_value * quantity

          withDiscount = truncateNumber(
            applyDiscount(
              itemDefaultFinalValue,
              form.general_discount || discount
            )
          )
        }

        return parseFloat(total) + parseFloat(withDiscount)
      }, 0)

      return generalFinalValue
    }

    const generalFinalValue = formServices.reduce((total, item) => {
      const { final_value, quantity, discount, default_value } = item

      let withDiscount = 0

      if (final_value) {
        withDiscount = truncateNumber(final_value)
      } else {
        const itemDefaultFinalValue = default_value * quantity

        withDiscount = truncateNumber(
          applyDiscount(
            itemDefaultFinalValue,
            form.general_discount || discount
          )
        )
      }

      return parseFloat(total) + parseFloat(withDiscount)
    }, 0)

    return generalFinalValue
  }

  useEffect(() => {
    let mounted = true
    if (currentService && mounted) {
      const newService = {
        ...currentService,
        quantity: 1,
        discount: '',
        final_time: currentService.execution_time,
        default_value_default: currentService.default_value,
        base_price: currentService.default_value,
        options: { type: 1, base: 0, altura: 0, diametro: 0 },
        is_rework: 0,
        tec_commission: '',
        images: [],
      }

      if (currentService.measureType.id === 2) {
        setOpen(true)
        setCurrentIndex(form.services.length)
      }

      newService.final_value = currentService.default_value
      newService.dateTime = Date.now()
      setForm({
        ...form,
        services: [...form.services, newService],
        final_value_discount:
          parseFloat(form.final_value_discount) +
          parseFloat(currentService.default_value),
      })

      if (!form.general_discount) return

      return setRecalculate(true)
    }
    return () => (mounted = false)
  }, [currentService])

  const noDiscount = useMemo(() => {
    if (form.dirty === true) {
      return form.services.reduce((total, item) => {
        const noDiscountValue = item.default_value * item.quantity
        return parseFloat(total) + parseFloat(noDiscountValue)
      }, 0)
    }
  }, [form.services])

  useEffect(() => {
    let mounted = true
    if (mounted && form.dirty === true) {
      setForm({
        ...form,
        total_without_discount: noDiscount,
      })
    }
    return () => (mounted = false)
  }, [noDiscount])

  // useEffect(() => {}, [form.total_without_discount])

  // Identificação por `getServiceItemKey` em vez de índice posicional.
  // Após drag-and-drop o índice não reflete mais a posição visual do item,
  // causando exclusão do item errado e desconto incorreto no total.
  // Item novo tem `id` do service_type (não do banco), por isso a chave usa o
  // `dateTime` nesse caso — mesmo identificador usado pelo DnD em TableService.
  const removeChildren = itemId => {
    const key = String(itemId)

    const target = form.services.find(s => getServiceItemKey(s) === key)
    const minusFinal = truncateNumber(target?.final_value)

    const items = form.services.filter(s => getServiceItemKey(s) !== key)

    setForm({
      ...form,
      services: items,
      final_value_discount: form.final_value_discount - minusFinal,
    })
  }

  const swapChildren = (indexA, indexB) => {
    const items = [...form.services]
    ;[items[indexA], items[indexB]] = [items[indexB], items[indexA]]
    setForm(prev => ({ ...prev, services: items }))
  }

  const reorderChildren = orderedItems => {
    setForm(prev => ({ ...prev, services: orderedItems }))
  }

  const updateFieldSelect = (name, value, key) => {
    const items = [...form.services]

    items[key].status_was_changed = items[key]?.status_id != value?.id
    items[key].status = value

    setForm({ ...form, services: items })
  }

  const openEdit = useCallback(index => {
    setCurrentIndex(index)
    setOpen(true)
  }, [])

  const initClient = async () => {
    try {
      const resp = await dispatch(findClient(client.id))
      const { data } = resp
      setForm({ ...form, client: data })
      setClientAddress({
        cep: data?.cep || '',
        street: data?.street || '',
        number: data?.number || '',
        complement: data?.complement || '',
        neighborhood: data?.neighborhood || '',
        city: data?.city || '',
        uf: data?.uf || '',
      })
    } catch (e) {
      console.error(e)
    }
  }

  const getServiceCommissionField = (services = [], activedCommission) => {
    const newServices = []

    services?.map(service => {
      if (!form.commission) {
        let commissioned_prop = {
          commissioned_client_id: null,
          commissioned_user_id: null,
          commissioned_supplier_id: null,
          commissioned_user: {},
        }

        return newServices.push({
          ...service,
          ...commissioned_prop,
        })
      }

      if (!service?.commissioned_person) {
        let commissioned_prop = {
          commissioned_client_id: null,
          commissioned_user_id: null,
          commissioned_supplier_id: null,
          commissioned_user: {},
        }

        return newServices.push({
          ...service,
          ...commissioned_prop,
        })
      }

      let commissioned_prop = {
        commissioned_user_id: service.commissioned_person.id,
      }

      if (service.commissioned_person.type == 2) {
        commissioned_prop = {
          commissioned_client_id: service.commissioned_person.id,
        }
      } else if (service.commissioned_person.type == 3) {
        commissioned_prop = {
          commissioned_supplier_id: service.commissioned_person.id,
        }
      }

      if (!activedCommission) {
        commissioned_prop = {}
      }

      return newServices.push({
        ...service,
        ...commissioned_prop,
      })
    })

    return newServices
  }

  const onSubmit = (
    client,
    redirect = false,
    isSubmit = false,
    noAdvanceTab = false
  ) => {
    const { onSubmit } = props

    const {
      services,
      general_discount,
      final_value_discount,
      total_without_discount,
      service_status_id,
      status,
    } = form

    const serviceStatusId = () => {
      if (form?.id && redirect && service_status_id == 1) return 2
      if (form?.id && !redirect && service_status_id == 2) return 2
      if (form.id && !redirect && service_status_id) return service_status_id

      if (!form.id && redirect) return 2
      if (!form.id && !redirect) return 1

      return service_status_id
    }

    let formmatedServices = services

    formmatedServices = getServiceCommissionField(services, form.commission)

    if (client) {
      const newValues = {
        ...form,
        client: {
          ...client,
          birthday: client.birthday
            ? format(new Date(client.birthday), 'yyyy-MM-dd')
            : null,
        },
        services: formmatedServices,
        discount: {
          general_discount,
          final_value_discount,
        },
        total: {
          total_without_discount,
        },
        status: serviceStatusId(),
        redirect: redirect,
        service_address_active: form?.service_address_active,
      }

      setForm(newValues)
      if (noAdvanceTab) return

      return setValue(prevValue => prevValue + 1)
    }

    const newValues = {
      ...form,
      services: formmatedServices,
      discount: {
        general_discount,
        final_value_discount,
      },
      total: {
        total_without_discount,
      },
      status: serviceStatusId(),
      redirect: redirect,
      // Com "Agendar" a API devolve uma mensagem de sucesso própria do agendamento
      ready_to_schedule: redirect,
    }

    setForm(newValues)

    if (isSubmit) {
      if (!form.client?.name) {
        return dispatch({
          type: SNACKBAR.HARDFAIL,
          error: {
            message: 'É necessário o nome do cliente!',
          },
        })
      }

      if (!form.client?.phone) {
        return dispatch({
          type: SNACKBAR.HARDFAIL,
          error: {
            message: 'É necessário o telefone do cliente!',
          },
        })
      }

      if (!form.know_way_id) {
        return dispatch({
          type: SNACKBAR.HARDFAIL,
          error: {
            message: 'É necessário o como conheceu do cliente!',
          },
        })
      }

      if (form.service_address_active && !form.client?.number) {
        return dispatch({
          type: SNACKBAR.HARDFAIL,
          error: {
            message: 'É necessário o número do endereço!',
          },
        })
      }

      if (redirect) {
        confirm({
          description: 'Deseja mesmo agendar a OS?',
          title: 'Tem certeza?',
          confirmationText: 'Sim',
          cancellationText: 'Cancelar',
          dialogProps: {
            fullWidth: true,
          },
        }).then(async () => {
          return onSubmit(newValues, redirect)
        })

        return
      }

      return onSubmit(newValues, redirect)
    }
  }

  const fillNewServices = (copyOs = {}, services = []) => {
    const { services: copyOsServices } = copyOs

    const newServices = copyOsServices?.map(copyOsService => {
      const {
        measureType = { id: null },
        quantity,
        serviceType,
      } = copyOsService

      const service = services.find(serv => serv.id == copyOsService.id)

      let newItem = { ...copyOsService }

      if (measureType.id === 1)
        newItem = { ...newItem, quantity: parseInt(quantity, 10) }

      newItem = {
        ...newItem,
        id: serviceType.id,
        status: null,
        default_value: service?.default_value,
        default_value_default: service?.default_value_default,
        base_price: service?.default_value,
        bar_code: null,
        technician_default: serviceType.technician_value,
        final_value: service?.final_value,
        dateTime: Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000,
        // Os documents copiados pertencem aos itens da OS de origem e não podem
        // ser reenviados como fotos deste item.
        documents: [],
        images: [],
      }

      return newItem
    })

    const value = newServices?.reduce((total, service) => {
      return total + parseFloat(service?.final_value)
    }, 0)

    setForm({
      ...form,
      final_value_discount: value,
      services: newServices,
    })
  }
  const handleReturnTab = () => {
    const tab = value - 1

    if (tab < 0) {
      return setValue(0)
    }

    return setValue(tab)
  }

  const handleSave = (redirect = false) => {
    return onSubmit(null, redirect, true)
  }

  useEffect(() => {
    if (!currentService) return
    setCurrentService()
  }, [currentService])

  useEffect(() => {
    if (paymentMethods && !data?.payment_options) {
      setForm(prevState => ({
        ...prevState,
        payment_options: [],
      }))

      paymentMethods?.map(paymentMethod => {
        setForm(prevState => ({
          ...prevState,
          payment_options: [
            ...prevState?.payment_options,
            {
              id: paymentMethod.name,
              value: paymentMethod.name,
              checked: false,
            },
          ],
        }))
      })
    }
  }, [paymentMethods])

  const setAllToRework = checked => {
    let items = form.services.map((s, i) => ({ ...s }))

    // Itens em status final (entregue/concluído/cancelado) ficam de fora do
    // "marcar todos" — a regra é abrir uma nova OS para eles. Desmarcar continua
    // valendo para todos.
    const hasEligibleItem = items.some(item => !isItemFinalized(item))

    if (checked && !hasEligibleItem) return toastError(REWORK_BLOCKED_MESSAGE)

    items.map((item, index) => {
      if (checked && isItemFinalized(item)) return item

      item.is_rework = checked
      return updateRework(item)
    })

    setForm({
      ...form,
      services: items,
      all_in_rework: checked,
      final_value_discount: returnFinalValue(items),
    })
  }

  useEffect(() => {
    const handleVerifyItemsRework = () => {
      let hasItemInRework = false
      let itemsInRework = 0
      // Itens em status final não podem entrar em retrabalho, então o "marcar
      // todos" considera apenas os elegíveis — senão o checkbox do header nunca
      // ficaria marcado numa OS que tenha item entregue/concluído/cancelado.
      let eligibleItems = 0

      form?.services?.map(item => {
        if (!isItemFinalized(item)) eligibleItems++

        if (item?.is_rework) {
          hasItemInRework = true
          itemsInRework++
        }
      })

      if (!hasItemInRework) return

      setForm({
        ...form,
        rework: hasItemInRework,
        all_in_rework: eligibleItems > 0 && itemsInRework >= eligibleItems,
      })
    }

    if (!form?.services?.length > 0) return

    handleVerifyItemsRework()
  }, [value])

  useEffect(() => {
    dispatch(fetchAttendanceInit(filters))
    dispatch(fetchDocumentContexts())
  }, [])

  useEffect(() => {
    if (typeof value != 'number') return

    history.replace(`${url}?value=${Number(value)}`)
  }, [value])

  const initRecurrenceTriggerValue = () => {
    if (data?.recurrence_days) return

    setForm(prev => ({
      ...prev,
      recurrence_days: recurrenceTrigger?.days,
    }))
  }

  const handleOpenCreateServiceType = () => {
    dispatch(fetchServiceType())
    setOpenCreateServiceType(true)
  }

  const handleCloseCreateServiceType = () => {
    dispatch(fetchAttendanceInit(filters))
    setOpenCreateServiceType(false)
  }

  const handleChangeTab = value => {
    /**
     *  @author Heitor Santos 13/08/2025
     * Este componente inteiro é muito sensivel
     * Se value for 1 (Servicos)
     * é necessario atualizar o formulário do cliente!
     */
    if (value == 1) return onSubmit(form?.client, false, false)
    setValue(value)
  }

  /**
   * @author Heitor Santos 26/05/2025
   * Este bloco de codigo foi parte de uma refatoracao nos calculos de desconto
   * Descontos gerais e do item
   * Foi adicionado uma lib (decimal.js). Não desconsidere usar para calculos decimais
   */
  const handleResetDiscount = () => {
    let { services: newServices } = form

    newServices?.map((item, index) => {
      const { quantity, default_value } = item

      item.discount = ''
      item.discount_value = ''
      item.final_value = quantity * default_value
    })

    setForm(prev => ({
      ...prev,
      general_discount: '',
      services: newServices,
      final_value_discount: returnFinalValue(newServices),
    }))

    setGeneralFinalAltered(false)
  }

  const applyDiscountForm = (finalValue = 0, discount = 0) => {
    let { final_value_discount, general_discount, services } = form

    if (finalValue) final_value_discount = finalValue
    if (discount) general_discount = discount

    let newServices = services?.map((s, i) => s)

    applicateMultipleDiscount(
      newServices,
      final_value_discount || 0,
      noDiscount,
      general_discount
    )

    setForm(prev => ({
      ...prev,
      services: newServices,
      general_discount: general_discount,
      final_value_discount: returnFinalValue(newServices),
    }))

    setPercentualDiscountAltered(false)
    setFinalValueAltered(false)
    setRecalculate(false)
  }

  const onChangeFinalValue = () => {
    //
  }

  const discountAverage = useMemo(() => {
    const { final_value_discount, general_discount } = form

    if (general_discount) return ''

    return getPercetageApplicated(
      noDiscount || 0,
      final_value_discount || 0
    ).toFixed(2)
  }, [form, noDiscount])

  const updateChildren = (index, newValue, prop, options = false) => {
    let items = form.services.map((s, i) => (i === index ? { ...s } : { ...s }))
    let item = items[index]

    if (options) {
      const { options } = item
      item.options = { ...options, [prop]: newValue }
    } else item[prop] = newValue

    const { general_discount } = form

    switch (prop) {
      case 'discount':
      case 'quantity':
        updateDiscountOrQuantity(item, general_discount)
        break
      case 'base':
      case 'altura':
      case 'diametro':
        updateMeasures(item)
        updateDiscountOrQuantity(item, general_discount)
        break
      case 'default_value':
        updateDiscountOrQuantity(item, general_discount)
        break
      case 'is_rework':
        // O checkbox já vem desabilitado para item concluído; esta guarda cobre
        // qualquer outro caminho que chame `updateChildren` direto. Sai antes do
        // `setForm`, então a mutação em `items` (cópia local) é descartada.
        if (newValue && isItemFinalized(item)) {
          return toastError(REWORK_BLOCKED_MESSAGE)
        }
        updateRework(item)
        break
      case 'final_value':
        updateFinalValue(item)
        break
      case 'bar_code':
        item.bar_code = newValue
        break
      case 'final_time':
        item.final_time = newValue
        break
      case 'order':
        item.order = newValue
        break
      default:
        break
    }

    setForm(prev => ({
      ...prev,
      services: items,
      discount_average: newValue,
      final_value_discount: returnFinalValue(items),
    }))

    if (form.general_discount) {
      return setRecalculate(true)
    }
  }

  /**
   * Atualiza só as fotos do item. Fora do `updateChildren` de propósito: foto não
   * mexe em valor/desconto, e o `updateChildren` recalcula o total a cada chamada.
   */
  const updateItemImages = (index, images) => {
    setForm(prev => ({
      ...prev,
      services: prev.services.map((service, i) =>
        i === index ? { ...service, images } : service
      ),
    }))
  }

  const handleApplyGeneralDiscount = () => {
    const { general_discount: discount } = form

    const valueWithDiscount = new Decimal(noDiscount || 0)
      .minus(getPercentValue(discount || 0, noDiscount || 0).toFixed(2))
      .toNumber(2)

    return applyDiscountForm(valueWithDiscount, discount)
  }

  const handleRecalculateFinalValue = () => {
    const { final_value_discount } = form

    const calculateDiscount = getPercetageApplicated(
      noDiscount || 0,
      final_value_discount || 0
    ).toFixed(2)

    return applyDiscountForm(final_value_discount, calculateDiscount)
  }

  const handleChangeGeneralDiscount = e => {
    const { value } = e

    setPercentualDiscountAltered(true)

    if (parseFloat(value) < 0) {
      toastError('O desconto deve ser um valor maior que 0')
      return handleResetDiscount()
    }

    setForm(prev => ({
      ...prev,
      discount_average: '',
      general_discount: value,
    }))
  }

  const handleChangeFinalValue = e => {
    const { value } = e

    setFinalValueAltered(true)

    if (parseFloat(value) > noDiscount) {
      toastError('O desconto deve ser um valor menor que 0%')
      return handleResetDiscount()
    }

    setForm({ ...form, final_value_discount: value })
  }

  const handleChangePersonalizedAddress = (
    active = form?.service_address_active
  ) => {
    let { client } = form

    if (active) client = { ...client, ...clientAddress }
    if (!active) client = { ...client, ...serviceAddress }

    setForm({
      ...form,
      client,
      service_address_active: !active,
    })
  }

  const handleKnowWayChange = value => {
    setForm({ ...form, know_way_id: value })
  }

  const handleBlurClientFields = (name, value, json) => {
    if (json) {
      return setForm({
        ...form,
        client: {
          ...form.client,
          ...json,
          birthday: json?.birthday
            ? format(new Date(json.birthday), 'yyyy-MM-dd 00:00:00')
            : null,
        },
      })
    }

    setForm({
      ...form,
      client: {
        ...form.client,
        [name]: value,
      },
    })
  }

  /**
   * CASHBACK - AREA
   */
  const searchClientCashback = async client_id => {
    dispatch(fetchClientCashback(client_id))
  }

  const initFormWhenCashback = () => {
    const { total_points = 0, cashback_point_value = 0 } = cashback || {}

    const cashbackValue = total_points * cashback_point_value

    // Na criação da OS o backend já debita os pontos aplicados (ServiceObserver
    // -> discountCashbackApplied), então em edição o saldo do cliente NÃO
    // inclui o que está aplicado nesta OS. O teto aplicável aqui é
    // saldo atual + aplicado nesta OS.
    const alreadyApplied = Number(data?.cashback_applied) || 0

    setForm(prev => ({
      ...prev,
      cashback_value: cashbackValue + alreadyApplied,
    }))
  }

  const handleChangeCashbackApplied = appliedAmount => {
    const maxCashback = Number(form?.cashback_value) || 0
    const finalValue = Number(form?.final_value_discount) || 0

    // Validações
    if (appliedAmount > maxCashback) {
      toastError(
        `Cashback não pode ser maior que R$ ${exportFormatedMoney(maxCashback)}`
      )
      return
    }

    if (appliedAmount > finalValue) {
      toastError(`Cashback não pode ser maior que o valor total`)
      return
    }

    if (appliedAmount < 0) {
      toastError('Cashback deve ser um valor positivo')
      return
    }

    // Recalcular final_value_discount
    const newFinalValueWithCashback = finalValue - appliedAmount

    setForm({
      ...form,
      cashback_applied: appliedAmount,
      final_value_with_cashback: newFinalValueWithCashback,
    })
  }

  /**
   * END CASHBACK - AREA
   */

  useEffect(() => {
    if (!percentualDiscountAltered) return
    handleApplyGeneralDiscount()
  }, [percentualDiscountAltered])

  useEffect(() => {
    if (!finalValueAltered) return
    handleRecalculateFinalValue()
  }, [finalValueAltered])

  useEffect(() => {
    if (!recalculate) return
    handleApplyGeneralDiscount()
  }, [recalculate])

  useEffect(() => {
    if (!form.dirty) return
    if (!data?.service_address_active) return
    handleChangePersonalizedAddress(false)
  }, [data, form.dirty])

  useEffect(() => {
    if (!recurrenceTrigger?.id) return
    initRecurrenceTriggerValue()
  }, [recurrenceTrigger])

  useEffect(() => {
    if (!form?.client?.id) {
      setForm(prev => ({ ...prev, cashback_value: 0 }))
      return dispatch(eraseClientCashback())
    }

    searchClientCashback(form?.client?.id)
  }, [form?.client?.id])

  useEffect(() => {
    // Em edição o saldo pode voltar zerado justamente porque os pontos foram
    // debitados nesta OS; sem olhar o `cashback_applied` o bloco de cashback
    // nunca renderizava na edição.
    if (!cashback?.total_points && !data?.cashback_applied) return
    initFormWhenCashback()
  }, [cashback, data?.cashback_applied])

  return (
    <Grid item xs={12} container spacing={2}>
      <Grid item xs={12} style={{ padding: '0' }}>
        <Tabs>
          <Tab
            tabIndex={0}
            value={value}
            setValue={handleChangeTab}
            icon={mdiAccountEdit}
            label="Cliente"
            removeNavigation={false}
          />
          <Tab
            tabIndex={1}
            value={value}
            setValue={handleChangeTab}
            icon={mdiWater}
            label="Serviços"
            removeNavigation={false}
          />
        </Tabs>
      </Grid>

      <Grid item container direction="row" xs={12}>
        <Grid item container xs={12}>
          {value === 0 && (
            <>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item sm={4} xs={12}>
                    <AsyncRequest
                      label={
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="center"
                          style={{ gap: '4px' }}
                        >
                          <Typography style={{ fontWeight: '700' }}>
                            Cliente já cadastrado?
                          </Typography>
                          Pesquise por nome ou telefone
                        </Grid>
                      }
                      link="client/find-by-name"
                      setForm={updateClient}
                      data={client}
                      name="client"
                      onClickButton={initClient}
                      disabledButton={Boolean(!client?.id)}
                    />
                  </Grid>

                  <Grid item sm={8} xs={12}>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="flex-end"
                      spacing={2}
                    >
                      <Grid item>
                        <Tooltip title="Endereço personalizado só será usado para esta OS.">
                          <span>
                            <Grid
                              container
                              alignItems="center"
                              justifyContent="flex-end"
                            >
                              <Grid item>
                                <Switch
                                  checked={form.service_address_active}
                                  onChange={() =>
                                    handleChangePersonalizedAddress()
                                  }
                                />
                              </Grid>
                              <Grid item style={{ color: colors.textGray }}>
                                Endereço Personalizado
                              </Grid>
                            </Grid>
                          </span>
                        </Tooltip>
                      </Grid>

                      {recurrenceTrigger?.id && (
                        <Grid item>
                          <Tooltip title="Dias de Recorrência">
                            <span>
                              <Grid
                                container
                                alignItems="center"
                                justifyContent="flex-end"
                              >
                                <Grid item style={{ color: colors.textGray }}>
                                  Dias de recorrência:
                                </Grid>
                                <Grid item>
                                  <TextField
                                    value={form?.recurrence_days}
                                    disabled={form?.scheduling_date_crm}
                                    fullWidth
                                    style={{
                                      textAlign: 'center',
                                      maxWidth: '80px',
                                    }}
                                    InputProps={{
                                      inputComponent: InputNumberCustom,
                                      inputProps: {
                                        thousandSeparator: ',',
                                        decimalSeparator: '.',
                                        allowedDecimalSeparators: false,
                                        decimalScale: 0,
                                        onValueChange: values => {
                                          updateField(
                                            'recurrence_days',
                                            values.value
                                          )
                                        },
                                        style: { textAlign: 'center' },
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </span>
                          </Tooltip>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Form
                  data={form?.client}
                  know_way_id={form?.know_way_id}
                  notShowPost
                  onSubmit={onSubmit}
                  onClose={onClose}
                  btnText="Avançar"
                  onBlurEvent={handleBlurClientFields}
                  icon={mdiChevronRight}
                  submitOnBlur
                  attendance
                  onKnowWayChange={handleKnowWayChange}
                />
              </Grid>
            </>
          )}

          {value === 1 && (
            <>
              <Grid container xs={12}>
                <Grid
                  item
                  xs={12}
                  style={{
                    padding: '0',
                    marginTop: '1em',
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'flex-end',
                    gap: '16px',
                  }}
                >
                  {!updateOnlyServiceValue && (
                    <Box style={{ flex: '1 1 280px', maxWidth: '400px' }}>
                      <SelectField
                        style={{ color: 'black', marginTop: '0px' }}
                        options={services}
                        setForm={setCurrentService}
                        data={currentService || null}
                        uniqueState
                        label="Selecione um serviço"
                      />
                    </Box>
                  )}

                  {!updateOnlyServiceValue &&
                    canCreate('tipos-servico', permissionUser) && (
                      <Box style={{ color: colors.textGray }}>
                        Não achou um serviço?
                        <br />
                        <Typography
                          target="_blank"
                          component={Button}
                          style={{
                            color: colors.secondary,
                            fontWeight: '700',
                            padding: 0,
                            margin: 0,
                            backgroundColor: 'transparent',
                            textTransform: 'capitalize',
                          }}
                          onClick={handleOpenCreateServiceType}
                        >
                          Clique Aqui
                        </Typography>{' '}
                        para cadastrar!
                      </Box>
                    )}

                  <Box
                    style={{
                      marginLeft: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                      color: colors.textGray,
                    }}
                  >
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                      <Switch
                        checked={form.commission}
                        onChange={() =>
                          setForm({ ...form, commission: !form.commission })
                        }
                      />
                      Comissão
                    </Box>

                    {!updateOnlyServiceValue && (
                      <Box style={{ display: 'flex', alignItems: 'center' }}>
                        <Switch
                          checked={form.rework}
                          key={`switch-rework-${form?.rework}`}
                          onChange={() =>
                            setForm({ ...form, rework: !form.rework })
                          }
                        />
                        Retrabalho
                      </Box>
                    )}
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={12}
                  container
                  style={{ padding: '0', marginTop: '1em' }}
                >
                  <Grid item xs={12}>
                    <TableServices
                      items={form.services}
                      classes={classes}
                      removeChildren={removeChildren}
                      updateChildren={updateChildren}
                      swapChildren={swapChildren}
                      reorderChildren={reorderChildren}
                      updateItemImages={updateItemImages}
                      discountDisabled={form.general_discount}
                      openEdit={openEdit}
                      formId={form.id}
                      updateFieldSelect={updateFieldSelect}
                      rework={form.rework}
                      commission={form.commission}
                      allInRework={form.all_in_rework}
                      setAllToRework={setAllToRework}
                      updateOnlyServiceValue={updateOnlyServiceValue}
                    />
                  </Grid>

                  <Grid item xs={12} style={{ marginTop: '1.5em' }}>
                    <TotalTable
                      noDiscount={noDiscount}
                      setForm={setForm}
                      form={form}
                      classes={classes}
                      discountAverage={discountAverage}
                      onChangeFinalValue={onChangeFinalValue}
                      setGeneralFinalAltered={setGeneralFinalAltered}
                      // updateFinalValue={updateFinalValue}
                      handleChangeGeneralDiscount={handleChangeGeneralDiscount}
                      handleChangeFinalValue={handleChangeFinalValue}
                      updateOnlyServiceValue={updateOnlyServiceValue}
                      handleChangeCashbackApplied={handleChangeCashbackApplied}
                    />

                    <Grid
                      item
                      container
                      xs={12}
                      style={{ marginTop: '1.5em' }}
                      justifyContent="flex-end"
                    >
                      <Box className={styles.footer}>
                        <IconButton
                          onClick={handleReturnTab}
                          className={styles.submmitButton}
                          style={{
                            backgroundColor: colors.grayMedium,
                            color: colors.primary,
                          }}
                        >
                          <Icon path={mdiChevronLeft} size={1} />
                          Voltar
                        </IconButton>

                        {!updateOnlyServiceValue && (
                          <IconButton
                            onClick={() => handleSave(true)}
                            className={styles.submmitButton}
                          >
                            <Icon path={mdiCalendarCheck} size={0.8} />
                            Agendar
                          </IconButton>
                        )}

                        <IconButton
                          onClick={() => handleSave(false)}
                          className={styles.submmitButton}
                        >
                          <Icon path={mdiCheckBold} size={0.8} />
                          <Typography>Salvar</Typography>
                        </IconButton>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>

      {value === 0 &&
        historicSlot &&
        form.client?.id &&
        createPortal(
          <ClientHistoric
            clientId={form.client.id}
            fillNewServices={fillNewServices}
          />,
          historicSlot
        )}

      {form.client?.opened_services && (
        <ModalShowOpenedServices openedServices={form.client.opened_services} />
      )}

      <Modal
        open={open}
        handleClose={handleClose}
        classes={classes}
        currentIndex={currentIndex}
        services={form.services}
        updateChildren={updateChildren}
        changeOptionType={changeOptionType}
      />

      <CreateServiceTypeModal
        open={openCreateServiceType}
        handleClose={handleCloseCreateServiceType}
      />
    </Grid>
  )
}

export default withStyles(styles)(Attendance)
